module.exports = __webpack_public_path__ + "img/login-b2c.bd71732c.jpg";